var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [
          _vm._v(
            _vm._s("Egreso de bodega " + (_vm.documento ? _vm.documento : ""))
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            { staticClass: "btn-success", on: { click: _vm.guardar } },
            [
              _c("i", { staticClass: "fa fa-save" }),
              _c("span", [_vm._v("Guardar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn-danger btn--text", on: { click: _vm.cerrar } },
            [
              _c("i", { staticClass: "fa fa-times" }),
              _c("span", [_vm._v("Cancelar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha_transaccion",
                  locale: "es",
                  "no-label": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD HH:mm:ss",
                  formatted: "YYYY-MM-DD HH:mm:ss",
                  label: "Seleccione fecha..."
                },
                model: {
                  value: _vm.form.fecha_transaccion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_transaccion", $$v)
                  },
                  expression: "form.fecha_transaccion"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha transacción:")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  filterable: false,
                  label: "descripcion",
                  placeholder: "Seleccione...",
                  options: _vm.bodegas,
                  id: "bodegas"
                },
                on: { input: _vm.inputBodega },
                model: {
                  value: _vm.selectedBodega,
                  callback: function($$v) {
                    _vm.selectedBodega = $$v
                  },
                  expression: "selectedBodega"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "bodegas" } }, [_vm._v("Bodega:")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-8 mb-2" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: { id: "nota", placeholder: "Escriba..." },
                model: {
                  value: _vm.form.nota,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "nota", $$v)
                  },
                  expression: "form.nota"
                }
              },
              [_c("span", [_vm._v("Nota:")])]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("tabla-egreso-bodega", {
                model: {
                  value: _vm.form.detalles,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "detalles", $$v)
                  },
                  expression: "form.detalles"
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        staticClass: "modal-buttons"
      },
      [
        _c(
          "button",
          { staticClass: "btn-success", on: { click: _vm.guardar } },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _c("span", [_vm._v("Guardar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn-danger btn--text", on: { click: _vm.cerrar } },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cancelar")])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d9b23d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9b23d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/EgresoBodega.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d9b23d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/EgresoBodega.vue
// module chunks = 0